/* globals $ */

import "../../../css/components/internal-menu.scss";

export default class InternalMenu {
  constructor($elem) {
    this.$elem = $elem;
    this.fixStickyness();
    $(window).resize(() => this.fixStickyness());
    $elem.find("a").click((e) => {
      e.preventDefault();
      let hash = $(e.currentTarget).attr("href");
      let $target = $(hash);
      if ($target.length) {
        $("html, body").animate(
          {
            scrollTop: $(hash).offset().top - $elem.height(),
          },
          300
        );
      }
    });
  }

  fixStickyness() {
    this.$elem.removeClass("sticky");
    if (
      $(window).width() > 600 ||
      this.$elem.find(".menu-wrapper.mobile-sticky").length
    ) {
      this.$elem.addClass("sticky");
    }
  }
}
